<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
          </div>
        </section>
      </b-card>

      <b-row>
        <b-col sm="6">
          <b-card>
            <FullCalendar defaultView="dayGridMonth"
                          :plugins="calendarPlugins"
                          :locale="calendarOptions.locale"
                          :weekends="true"
                          :events="calendarOptions.event"
                          :selectable="true"
                          :titleFormat="calendarTitleFormat"
                          @dateClick="dateClick "/>
          </b-card>
        </b-col>
        <b-col sm="6">
          <b-card>
            <b-row class="mb-3 align-items-start">
              <b-col md="8">
                <h2>{{moment(this.crud.form.date).format('DD')}} de
                    {{moment(this.crud.form.date).format('MMMM')}} de
                    {{moment(this.crud.form.date).format('YYYY')}}</h2>
              </b-col>
              <b-col md="4" class="d-flex justify-content-end">
                <b-button variant="link"
                          class="list-view-icon-btn list-view-icon-btn--primary"
                          v-b-tooltip.hover title="Agregar Horas"
                          aria-label="Agregar Horas"
                          @click="add()">
                  <AppIcon name="add" />
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-table class="mb-0 app-table app-table--compact crud-hours-table"
                        responsive="sm"
                        :stacked="isMobileViewport ? 'md' : false"
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :items="table.items"
                        :fields="table.fields"
                        v-if="table.items.length">

                    <template v-slot:table-colgroup="scope">
                      <col
                        v-for="field in scope.fields"
                        :key="field.key"
                        :style="{ width: isMobileViewport ? 'auto' : field.width }"
                      >
                    </template>

                    <template v-slot:cell(assignment)="data">
                      <div class="crud-hours-assignment crud-hours-assignment--project" v-if="data.item.projects_id">
                        <AppIcon name="business_center" class="crud-hours-assignment__icon" />
                        <div>
                          <div><b>{{data.item.projects.name}}</b></div>
                          <div class="text-muted small">{{data.item.projects.customer.name}}</div>
                        </div>
                      </div>
                      <div class="crud-hours-assignment crud-hours-assignment--activity" v-else>
                        <AppIcon name="task_alt" class="crud-hours-assignment__icon" />
                        <div><b>{{data.item.activity.name}}</b></div>
                      </div>
                    </template>

                    <template v-slot:cell(description)="data">
                      <div>
                        {{ data.item.description }}
                      </div>
                    </template>

                    <template v-slot:cell(hours)="data">
                      <b>{{ data.item.hours }} hs</b>
                    </template>

                    <template v-slot:cell(f_action)="data">
                      <b-dropdown right
                                  no-caret
                                  size="sm"
                                  variant="link"
                                  boundary="window"
                                  :toggle-class="isMobileViewport ? 'crud-hours-action-toggle-labeled' : 'app-table-action-toggle'">
                        <template #button-content>
                          <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                          <span v-if="isMobileViewport">Opciones</span>
                        </template>
                        <b-dropdown-item @click="edit(data.item)">
                          <AppIcon name="edit" /> Editar
                        </b-dropdown-item>
                        <b-dropdown-item @click="remove(data.item)">
                          <AppIcon name="delete" class="text-danger" /> Eliminar
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                </b-table>
                <EmptyState v-else
                            icon="history"
                            title="No se encontraron registros"
                            description="No hay horas cargadas para el día seleccionado." />
              </b-col>
            </b-row>
            <b-row class="mt-3" v-if="table.items.length">
              <b-col md="12">
                <div class="app-modal-detail-list">
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Proyectos</span>
                    <span class="app-modal-detail-list__value">{{this.totalProjects.toFixed(2)}} Hs</span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Actividades</span>
                    <span class="app-modal-detail-list__value">{{this.totalActivity.toFixed(2)}} Hs</span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label"><b>Total Trabajado</b></span>
                    <span class="app-modal-detail-list__value"><b>{{(this.totalActivity + this.totalProjects).toFixed(2)}} Hs</b></span>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card>

          <b-card body-class="py-2">
            <div class="list-view-footer">
              <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
                <AppIcon name="back" />
                Volver
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon :name="modal.form.icon" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>

        <b-row>
          <b-col md="12">
            <b-form-group label="Tipo">
              <b-form-radio-group
                v-model="crud.form.type.selected"
                :options="crud.form.type.options"
                name="radios-type"
                buttons
                button-variant="outline-dark"
                size="sm"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>

          <b-col md="8">
            <FindObject type="project"
                        @select-object="loadProjects($event)"
                        :valueID="crud.form.projects_id"
                        render="search"
                        v-show="crud.form.type.selected == 'project'"
                        :where="conditionProjectActive"/>

            <FindObject type="activity"
                        @select-object="loadActivity($event)"
                        :valueID="crud.form.activity_id"
                        render="search"
                        v-show="crud.form.type.selected == 'activity'"/>
          </b-col>

          <b-col md="4">
            <b-form-group label="Horas">
              <b-form-input type="number"
                            size="sm"
                            v-model="crud.form.hours"
                            step='0.01'
                            placeholder="Ingresar una hora">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Descripción">
              <app-textarea
                v-model="crud.form.description"
                size="sm"
                placeholder="Ingresa la descripción de la tarea"
              ></app-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Profiles from '@/config/profiles'
  import Error from '@/handler/error'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Theme from '@/config/theme'
  import moment from 'moment'
  import FindObject from '@/components/inc/find/findObject'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  import FullCalendar from '@fullcalendar/vue'
  import dayGridPlugin from '@fullcalendar/daygrid'
  import esLocale from '@fullcalendar/core/locales/es';
  import interactionPlugin from '@fullcalendar/interaction';

  export default {
    components: {
      FindObject,
      FullCalendar,
      TabHeaderActions
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PROYECTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudHours',
          elements: {}
        },
        calendarPlugins: [ dayGridPlugin, interactionPlugin ],
        calendarOptions: {
          locale: esLocale,
          event: []
        },
        isMobileViewport: false,
        table : {
          items: [],
          fields: [],
        },
        crud: {
          form: {
            date: moment().format('YYYY-MM-DD'),
            type: {
              selected: 'project',
              options: [
                { text: 'Proyectos', value: 'project' },
                { text: 'Actividades', value: 'activity' }
              ]
            },
            projects_id: 0,
            projects: null,
            activity_id: 0,
            activity: null,
            hours: 0,
            description: '',
            staff_id: Helper.getStaffId()
          }
        },
        modal: {
          form: {
            active: false,
            title: '',
            icon: 'add',
          },
        }
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted () {
      if(!this.isEmployee) {
        this.$router.push({ name: 'Error403' })
      }

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.loadFieldTable()

      moment.locale('es');
      this.load()

      // Acción directa desde la paleta de comandos: abrir el alta al
      // entrar, con el tipo (Proyectos/Actividades) que haya pedido la
      // acción -- add() ya defaultea a 'project', pero se deja explícito.
      if (this.$route.query.new == '1') {
        this.add()
        if (this.$route.query.mode) this.crud.form.type.selected = this.$route.query.mode
        // Limpia el query apenas se consume -- si no, la pestaña queda con
        // ?new=1 pegado para siempre y volver a ella (activated, keep-alive)
        // reabriría el alta de nuevo aunque el usuario solo quiera ver el
        // listado.
        this.$router.replace({ path: this.$route.path, query: {} }).catch(() => {})
      }

      this._start = true
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      }

      this.load()

      // Misma acción directa que en mounted(): si la pestaña ya estaba
      // montada (keep-alive), "mounted" no vuelve a correr y la paleta de
      // comandos no abriría nada sin este chequeo acá también.
      if (this.$route.query.new == '1') {
        this.add()
        if (this.$route.query.mode) this.crud.form.type.selected = this.$route.query.mode
        // Limpia el query apenas se consume -- si no, la pestaña queda con
        // ?new=1 pegado para siempre y volver a ella (activated, keep-alive)
        // reabriría el alta de nuevo aunque el usuario solo quiera ver el
        // listado.
        this.$router.replace({ path: this.$route.path, query: {} }).catch(() => {})
      }
    },
    watch: {
      // Si el viewport cruza el breakpoint mobile (resize/rotación), las
      // clases de alineación y el label del kebab tienen que recalcularse.
      isMobileViewport() {
        this.loadFieldTable()
      },
    },
    computed: {
      totalActivity: function() {
        var total = 0
        this.table.items.forEach(element => {
          if(element.activity_id) {
            total = total + parseFloat(element.hours)
          }
        })
        return total
      },
      totalProjects: function() {
        var total = 0
        this.table.items.forEach(element => {
          if(element.projects_id) {
            total = total + parseFloat(element.hours)
          }
        })
        return total
      },
      isEmployee(){
        if(Helper.getEmployee() || Helper.getEmployee().permission_admin_projects) {
          return true
        } else {
          return false
        }
      },
      conditionProjectActive(){
        return [{field: 'status', condition: 'active'}];
      },
    },
    methods: {
      // El titleFormat automático del locale es.js arma "enero de 2026" (el
      // "de" es gramática española correcta para esa combinación, no un
      // error del locale) -- queremos solo "Enero 2026", así que se arma a
      // mano en vez de dejarle el formateo por defecto a FullCalendar.
      //
      // moment.utc(), NO moment(): arg.date.marker está en el dominio UTC
      // (medianoche UTC = 1° del mes) sin importar el timezone real; leerlo
      // con moment() local lo corre un mes atrás en husos negativos (ej.
      // Argentina UTC-3: "Julio" en vez de "Agosto").
      calendarTitleFormat(arg) {
        var text = moment.utc(arg.date.marker).format('MMMM YYYY')
        return text.charAt(0).toUpperCase() + text.slice(1)
      },
      // RESPONSIVE
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      loadFieldTable() {
        this.table.fields = []
        // .text-wrap (Bootstrap, !important) pisa el nowrap+ellipsis global
        // de .app-table td — un nombre de proyecto/cliente o una
        // descripción larga necesitan pasar a un segundo renglón en vez de
        // cortarse y correr a Horas/Acciones fuera de la vista.
        this.table.fields.push({key: 'assignment', label: 'Asignación', class:"align-middle text-wrap " + this.alignClass('text-left'), width:"25%"})
        this.table.fields.push({key: 'description', label: 'Detalle', class:"align-middle text-wrap " + this.alignClass('text-left'), width:"55%"})
        this.table.fields.push({key: 'hours', label: 'Horas', class:"align-middle " + this.alignClass('text-center'), width:"15%"})
        // Sin drawer que aloje las acciones en mobile, el kebab se
        // conserva ahí también, con label y texto "Opciones" visibles.
        this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right'), width:"5%"})
      },
      dateClick(date) {
        this.crud.form.date = date.dateStr
        this.getHours()
      },
      load(){
        this.loadCalendar()
        this.getHours()
      },
      loadCalendar() {
        let loader = this.$loading.show();

        this.calendarOptions.event = []

        var data = {
          staff_id: Helper.getStaffId()
        }
        var result = serviceAPI.obtenerHorasByEmployee(data)

        result.then((response) => {
          var data = response.data

          // Variantes "-hover" (más oscuras) en vez de los tokens pasteles
          // originales: FullCalendar pinta el título en blanco por default,
          // y contra un fondo claro el texto quedaba casi ilegible.
          data.projects.forEach(element => {
            var event = {}

            event = {
              title: 'Proyectos: ' + element.hours + ' hs',
              start: element.date,
              // Los eventos de día completo usan end exclusivo en FullCalendar.
              allDay: true,
              end: moment(element.date).add(1, 'day').format('YYYY-MM-DD'),
              color: Theme.getColor(Theme.TOKENS.successHover, '#185f3f'),
              textColor: '#ffffff',
            }
            this.calendarOptions.event.push(event)
          });

          data.activity.forEach(element => {
            var event = {}

            event = {
              title: 'Actividades: ' + element.hours + ' hs',
              start: element.date,
              allDay: true,
              end: moment(element.date).add(1, 'day').format('YYYY-MM-DD'),
              color: Theme.getColor(Theme.TOKENS.warningHover, '#854c00'),
              textColor: '#ffffff',
            }
            this.calendarOptions.event.push(event)
          });

          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      },
      getHours() {
        let loader = this.$loading.show();
        var data = {
          staff_id: Helper.getStaffId(),
          date: this.crud.form.date
        }
        var result = serviceAPI.obtenerHorasByDia(data)

        result.then((response) => {
          this.table.items = response.data

          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.projects_id = 0
        this.crud.form.projects = null
        this.crud.form.activity_id = 0
        this.crud.form.activity = null
        this.crud.form.hours = 0
        this.crud.form.description = ''
        this.crud.form.type.selected = 'project'

        this.modal.form.title = "Agregar Horas"
        this.modal.form.icon = 'add'
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id

        if(item.projects_id){
          this.crud.form.projects_id = item.projects.id
          this.crud.form.projects = item.projects
          this.crud.form.type.selected = 'project'
        } else {
          this.crud.form.activity_id = item.activity.id
          this.crud.form.activity = item.activity
          this.crud.form.type.selected = 'activity'
        }

        this.crud.form.hours = item.hours
        this.crud.form.description = item.description

        this.modal.form.title = "Editar Horas"
        this.modal.form.icon = 'edit'
        this.modal.form.active = true
      },
      // Confirm estándar: header con ícono + tinte suave
      // (.app-confirm-header) en vez de header-bg-variant sólido, size
      // 'sm' siempre, y okVariant/headerClass según sea o no destructiva.
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      remove(item) {
        this.crud.form.id = item.id
        if(item.projects_id) {
          this.crud.form.name = item.projects.name
        } else {
          this.crud.form.name = item.activity.name
        }

        this.confirmDialog('¿Desea borrar el item (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Hora',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarHora(this.crud.form.id);

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();
        if (this.crud.form.id) {
          var result = serviceAPI.editarHora(this.crud.form);
        } else {
          var result = serviceAPI.agregarHora(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.load()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      loadProjects (object) {
        if(object){
          this.crud.form.projects = object
          this.crud.form.projects_id = object.id
          this.crud.form.activity = null
          this.crud.form.activity_id = 0
        } else {
          this.crud.form.projects = null
          this.crud.form.projects_id = 0
        }
      },
      loadActivity (object) {
        if(object){
          this.crud.form.activity = object
          this.crud.form.activity_id = object.id
          this.crud.form.projects = null
          this.crud.form.projects_id = 0
        } else {
          this.crud.form.activity = null
          this.crud.form.activity_id = 0
        }
      },
    }
  }
</script>
<style scoped>
  /* Celda "Asignación": ícono + texto en vez de un fondo sólido de celda
     (_cellVariants) — ese bloque de color competía visualmente con el
     tinte suave del header de .app-table--compact y se veía como dos
     sistemas de diseño mezclados. */
  .crud-hours-assignment {
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }
  .crud-hours-assignment__icon {
    flex-shrink: 0;
    margin-top: 2px;
  }
  .crud-hours-assignment--project .crud-hours-assignment__icon {
    color: var(--app-color-success);
  }
  .crud-hours-assignment--activity .crud-hours-assignment__icon {
    color: var(--app-color-warning);
  }

  /* Excepción al kebab mudo de .app-table: esta tabla no tiene drawer que
     aloje las acciones, así que se conserva también en mobile — como link
     de texto alineado a la izquierda, no como botón con caja. */
  .btn.crud-hours-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }
  .btn.crud-hours-action-toggle-labeled:hover,
  .btn.crud-hours-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  /* Pisa la regla global que oculta el label del último field y lo alinea
     a la derecha (pensada para el kebab ícono-only sin texto). */
  @media (max-width: 767.98px) {
    .crud-hours-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
    .crud-hours-table.app-table.b-table-stacked-md > tbody > tr > td:last-child {
      text-align: left !important;
    }
  }
</style>
